import { Transaction } from '../types/budget';

export const filterTransactions = (
  transactions: Transaction[],
  filters: {
    category?: string;
    responsible?: string;
    destination?: string;
    amountType?: 'income' | 'expense';
  }
): Transaction[] => {
  return transactions.filter((t) => {
    if (filters.category && t.category !== filters.category) return false;
    if (filters.responsible && t.responsible !== filters.responsible) return false;
    if (filters.destination && t.destination !== filters.destination) return false;
    if (filters.amountType === 'income' && t.amount < 0) return false;
    if (filters.amountType === 'expense' && t.amount >= 0) return false;
    return true;
  });
};

export const sortTransactions = (
  transactions: Transaction[],
  sortField: keyof Transaction,
  sortDirection: 'asc' | 'desc'
): Transaction[] => {
  return [...transactions].sort((a, b) => {
    let comparison = 0;
    if (sortField === 'amount') {
      comparison = a.amount - b.amount;
    } else {
      comparison = String(a[sortField]).localeCompare(String(b[sortField]));
    }
    return sortDirection === 'asc' ? comparison : -comparison;
  });
};

export const getUniqueValues = <T extends keyof Transaction>(
  transactions: Transaction[],
  field: T
): Transaction[T][] => {
  return Array.from(new Set(transactions.map((t) => t[field]))).sort() as Transaction[T][];
};
